import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { AppState } from '../reducers/root.reducer';

const profile = (state: AppState) => state.common.profile;

const getProfile = createSelector(profile, (profile) => profile);

const getFullname = createSelector(getProfile, (profile) => {
    if (!profile) {
        return '';
    }

    const { firstName, lastName } = profile;

    if (firstName && firstName.length > 0 && lastName && lastName.length > 0) {
        return `${firstName} ${lastName}`;
    }

    return '';
});

const getProfileName = createSelector(
    getProfile,
    getFullname,
    (profile, name) => {
        if (!profile) {
            return '';
        }

        return name.length > 0 ? name : profile.email;
    },
);

const getEmail = createSelector(getProfile, (profile) => profile?.email);

const ProfileSelectors = {
    getProfile,
    getFullname,
    getProfileName,
    getEmail,
    useGetEmail,
};

function useGetEmail() {
    return useSelector(getEmail);
}

export default ProfileSelectors;
